import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { DownloadSecurityContainerWindowData } from '../types/download-security-container-data';
import { htmlEncode } from '../../../utils/escape.utils';
import { WEB_COMPONENT_GZ_COPY_TO_CLIPBOARD } from '../../../webcomponents.constants';
import { ElementClass, elementClassListAdd, elementClassListRemove } from '../../../utils/htmlElement.utils';
import { translateFn } from '../../../utils/translator.helper';
import { LinkType } from 'apps/webcomponents/src/ui/gzLinkComponent/types';

export class DownloadSecurityContainerView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');

    this.dom.$downloadInstructions = this.shadow.querySelector('#downloadInstructions');

    this.dom.$kubernetesTitle = this.shadow.querySelector('#kubernetesTitle');
    this.dom.$kubernetesDownloadSecurityContainerScriptInput = this.shadow.querySelector(
      '#kubernetesDownloadSecurityContainerScriptInput'
    );

    this.dom.$helmTitle = this.shadow.querySelector('#helmTitle');
    this.dom.$helmDownloadSecurityContainerScriptInput = this.shadow.querySelector(
      '#helmDownloadSecurityContainerScriptInput'
    );

    this.dom.$openShiftTitle = this.shadow.querySelector('#openShiftTitle');
    this.dom.$openShiftDownloadSecurityContainerScriptInput = this.shadow.querySelector(
      '#openShiftDownloadSecurityContainerScriptInput'
    );

    this.dom.$copyOpenShift = this.shadow.querySelector('#copyOpenShiftDownloadSecurityContainerScript');

    this.dom.$copyToClipboardItems = this.shadow.querySelectorAll(WEB_COMPONENT_GZ_COPY_TO_CLIPBOARD);

    this.getTranslations();
    this.setTranslatedStrings();
    this.setTitleStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = {
      versionErrorDialogTitle: 'Error loading Security Container scripts',
      versionErrorDialogMessage: `${htmlEncode(
        translateFn(
          'The scripts require BEST for Linux agent version 7 or higher. You can download the required version from '
        )
      )} <gz-link type="underline" id="goToComponentsLink" href="#" class="hydragrid-edit-link"><span>${htmlEncode(
        translateFn('Configuration > Update > Components.')
      )}</span></gz-link>`,
    };
  }

  setTranslatedStrings() {
    this.dom.$copyToClipboardItems.forEach(el => {
      el.confirmationMessage = this.commonStrings.copied;
    });
  }

  buildErrorView(error: Error) {
    this.dependencies.CloseDownloadSecurityContainerWindow();
    this.disconnected();

    const dialog = this.buildDialogElement({
      title: this.translations.versionErrorDialogTitle,
      message: this.translations.versionErrorDialogMessage,
      actionButtonString: this.commonStrings.close,
    });

    const closeButton = dialog.footerContent?.querySelector('gz-button');
    if (closeButton) {
      closeButton.setAttribute('color', 'secondary');
    }

    const goToComponentsLink = dialog.bodyContent.querySelector('gz-link');
    if (goToComponentsLink) {
      goToComponentsLink.addEventListener('click', () => {
        this.dependencies.GoToComponentsPanel();
        dialog.close();
      });
    }
  }

  buildSuccessView(data: DownloadSecurityContainerWindowData) {
    this.dom.$kubernetesDownloadSecurityContainerScriptInput.setAttribute('value', data.kubernetesScript);
    this.dom.$helmDownloadSecurityContainerScriptInput.setAttribute('value', data.kubernetesScript);
    this.dom.$openShiftDownloadSecurityContainerScriptInput.setAttribute('value', data.openShiftScript);

    this.dom.$kubernetesDownloadSecurityContainerScriptInput.innerHTML = data.kubernetesScript;
    this.dom.$helmDownloadSecurityContainerScriptInput.innerHTML = data.helmScript;
    this.dom.$openShiftDownloadSecurityContainerScriptInput.innerHTML = data.openShiftScript;

    if (data.openShiftScript.length) {
      elementClassListRemove(this.dom.$copyOpenShift, ElementClass.HIDDEN);
      elementClassListRemove(this.dom.$openShiftTitle, ElementClass.HIDDEN);
    } else {
      elementClassListAdd(this.dom.$copyOpenShift, ElementClass.HIDDEN);
      elementClassListAdd(this.dom.$openShiftTitle, ElementClass.HIDDEN);
    }

    this.dom.$downloadInstructions.innerHTML = `${htmlEncode(
      this.dependencies.translateFn(
        'To set up a Security Container use these scripts in your container management platform. Make sure BEST for Linux is uninstalled from targeted container hosts.'
      )
    )} <gz-link type="${LinkType.UNDERLINE}" id='gravityZoneDownloadKbUrl' href=${
      data.learnMoreLink
    }><span>${htmlEncode(this.dependencies.translateFn('Learn more'))}</span></gz-link>`;
  }

  private setTitleStrings() {
    this.dom.$kubernetesTitle.innerHTML = 'Kubernetes';
    this.dom.$helmTitle.innerHTML = 'Helm';
    this.dom.$openShiftTitle.innerHTML = 'Kubernetes OpenShift';
  }
}
